export default "__VITE_ASSET__BJWJHnT6__"